import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export const EnquiryDialog = ({ open, onOpenChange, product }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[92vh] overflow-y-auto rounded-2xl bg-white sm:max-w-xl" data-testid="enquiry-dialog">
      <DialogHeader>
        <DialogTitle className="font-display text-2xl">Enquire about {product?.name || "our products"}</DialogTitle>
        <DialogDescription>Ask about sizes, ingredients, pricing, delivery and ordering. We usually reply on WhatsApp or email.</DialogDescription>
      </DialogHeader>
      {open ? <EnquiryForm defaultProduct={product?.slug || "general"} compact /> : null}
      <div className="flex flex-wrap items-center gap-3 border-t pt-4 text-sm text-muted-foreground">
        <span>Prefer to chat?</span>
        <WhatsAppButton message={product?.whatsappMessage} product={product?.slug} label="WhatsApp instead" className="btn btn-secondary" testid="enquiry-dialog-whatsapp" location="dialog" />
      </div>
    </DialogContent>
  </Dialog>
);
